import { ICountryData } from 'stores/countries/types';

// Capital coordinates are left out on purpose: an empty number input is caught by `required`.
export const defaultValues: Partial<Omit<ICountryData, 'id'>> = {
  defaultEngName: '',
  code: '',
  domain: '',
  status: 'Inactive',
  capitalName: '',
};
